import { render, staticRenderFns } from "./MenuItemExpanded.vue?vue&type=template&id=4e0f0e19&scoped=true&"
import script from "./MenuItemExpanded.vue?vue&type=script&lang=ts&"
export * from "./MenuItemExpanded.vue?vue&type=script&lang=ts&"
import style0 from "./MenuItemExpanded.vue?vue&type=style&index=0&id=4e0f0e19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0f0e19",
  null
  
)

export default component.exports